module.exports = __webpack_public_path__ + "static/img/Pagar-2020-72.779f6a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Pagar-2020-72.png
// module id = DDj+
// module chunks = 0